
import { Navigation, Autoplay } from "swiper/modules";
import { FaFacebook } from "react-icons/fa";
import { useState } from "react";
import { useEffect } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "./AllMembersPageCss/MembersCarousel.css";
import logoImg from "../../Assets/rbdLogo.png";
import ExpertProfileModal from "../AboutPageElement/ExpertProfileModal";
import AnimatedText from "../../AnimatedText";
import doctorImg from '../../Assets/doctorCardImg.jpg'

// import MembersData from "../../DB/MembersData";
import { OurAllMember } from "../../api/api";
import { Swiper, SwiperSlide } from "swiper/react";
import MemberDetailsModal from "../AboutPageElement/MemberDetailsModal";
import CustomLoader from "../../common/loader/CustomLoader";


export default function MembersCarousel() {
    const [selectedMember, setSelectedMember] = useState(null);
    const [activeTab, setActiveTab] = useState("All Members");
    const [members,setMember] = useState([]);
    const[loading,setLoading] = useState(false)
    const[message,setMessage] = useState("");
    


    const categories = [
        "All Members",
        "Pathologist",
        "Radiologist",
        "Cardiologist",
        "Pulmonologist",
        "Urologist",
        "Gastroenterologist",
    ];

    // const members = MembersData[activeTab] || [];
    console.log("members====>",members);


    // calling api 
        useEffect(() => {
            fetchOurAllMember();
        }, [activeTab]);
    
    
        // const fetchOurAllMember = async () => {
        //     const payload =  activeTab === "All Members" ? {} : { specialization: activeTab };
        //     try {
        //         setLoading(true);
        //         const res = await OurAllMember(payload);
        //         if (res?.data?.status === "Success") {
        //             const apiData = res?.data?.data || [];
    
        //             if (apiData.length > 0) {
        //                 //fetch data in setMember 
        //                 setMember(apiData);
        //                 setMessage(""); // clear message when data found
        //             } else {
        //                 // set empty array when data not found 
        //                 setMember([]);
        //                 setMessage("No data found");// set message when data not found 
        //             }
        //         } else {
        //             setMember([]);
        //             setMessage("Problem on API");
        //         }
    
    
    
        //         console.log("res.data===>", res?.data);
    
    
    
        //     } catch (error) {
        //         console.error("Error fetching  faq data :", error);
        //     } finally {
        //         setLoading(false);
               
        //     }
        // };
    
    // complete api calling 



    const fetchOurAllMember = async () => {
  const payload =
    activeTab === "All Members"
      ? {}
      : {
          specialization: activeTab.trim().toLowerCase(),
        };

  try {
    setLoading(true);
    const res = await OurAllMember(payload);

    if (res?.data?.status === "Success") {
      const apiData = res?.data?.data || [];

      if (apiData.length > 0) {
        setMember(apiData);
        setMessage("");
      } else {
        setMember([]);
        setMessage("No data found");
      }
    } else {
      setMember([]);
      setMessage("Problem on API");
    }
  } catch (error) {
    console.error("Error fetching member data:", error);
  } finally {
    setLoading(false);
  }
};

console.log("members through api calling data ==>",members);

console.log("selectedMember====>",selectedMember);



    
    return (
        <>
        {loading && < CustomLoader/>}
            <section className="members-section">
                <div className="ourPackageUpperSection">
                    <AnimatedText tag="h2" type="words" y={30} className="rb-title ourpackageTitle">
                        Meet Our Experts
                    </AnimatedText>
                    <div className="textParaSection">
                        <p className="paraText faqPara">
                            At RB Diagnostics, our strength lies in the expertise of our team. From experienced doctors to dedicated healthcare professionals, <br /> every member works with precision and care to ensure accurate diagnostics and compassionate service.
                        </p>
                    </div>
                </div>

                {/* Desktop Buttons */}
                <div className="midNavButtons desktop-only">
                    {categories.map((category) => (
                        <button
                            key={category}
                            className={`navBtn ${activeTab === category ? "active" : ""}`}
                            onClick={() => {
                                setActiveTab(category);
                            }}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                {/* Mobile Dropdown */}
                <div className="mobileDropdownContainer mobile-only" style={{marginBlock:"2rem"}}>
                    <select
                        className="faqDropdown"
                        value={activeTab}
                        onChange={(e) => {
                            setActiveTab(e.target.value);
                        }}
                    >
                        {categories.map((category) => (
                            <option key={category} value={category}>
                                {category}
                            </option>
                        ))}
                    </select>
                </div>



                <Swiper
                className="customSwiperDoctorProfile"
                    modules={[Navigation, Autoplay]}
                    spaceBetween={30}
                    slidesPerView={4}
                    autoplay={{ delay: 2500 }}
                    loop={true}
                    breakpoints={{
                        320: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 4 },
                    }}
                >
                    {members.length > 0 ? (
                        members.map((member, i) => (
                            <SwiperSlide key={i}>
                                <div className="member-card">
                                    <img
                                        src={member.DoctorPictureUrl  || doctorImg}
                                        alt={`${member.DocName} - ${member.specialization}`}

                                        className="member-photo"
                                    />
                                    <div className="rbdLogoWatermark">
                                        <img className="logoImgCss" src={logoImg} alt="RBD" />
                                    </div>

                                    <div className="member-info">
                                        <div className="member-info-first">
                                            {member.facebook && (
                                                <a
                                                    href={member.facebook}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="social-icon"
                                                >
                                                    <FaFacebook size={20} />
                                                </a>
                                            )}
                                            <h4 className="member-name">Dr. {member.DocName}</h4>
                                            <p className="member-role">{member.specialization}</p>
                                        </div>

                                        {/* {member.AboutDoctor && ( */}
                                            <button
                                                className="rbdButton view-details-btn"
                                                onClick={() => setSelectedMember(member)}
                                            >
                                                <span className="btn-text">View Details</span>
                                            </button>
                                        {/* )} */}
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))
                    ) : (
                        <p className="no-members">No members available in this category.</p>
                    )}
                </Swiper>
            </section>

            {/* Profile Modal */}
            {/* <ExpertProfileModal
                isOpen={!!selectedMember}
                onClose={() => setSelectedMember(null)}
                expert={
                    selectedMember
                        ? {
                            name: selectedMember.DocName,
                            role: selectedMember.specialization,
                            image: selectedMember.DoctorPictureUrl,
                            description: selectedMember.AboutDoctor,
                        }
                        : null
                }
                
            /> */}

            <MemberDetailsModal
                isOpen={!!selectedMember}
                onClose={() => setSelectedMember(null)}
                expert={
                    selectedMember
                        ? {
                            name: selectedMember.DocName,
                            role: selectedMember.specialization,
                            image: selectedMember.DoctorPictureUrl,
                            description: selectedMember.AboutDoctor,
                        }
                        : null
                }
                
            />
          
            
        </>
    );
}